import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import MembershipPreferenceView from '../../Model/Individual/StatisticsModel/MembershipPreferenceView';

import IntroMarkdown from './IntroMarkdown';

export default function MembershipPreferenceRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { intro, rankings, totalCount, totalRevenue, topCards, avgReRegRate } = data;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper $isDark={isDark}>
        <MembershipPreferenceView
          rankings={rankings || []}
          totalCount={totalCount || 0}
          totalRevenue={totalRevenue || 0}
          topCards={topCards || null}
          avgReRegRate={avgReRegRate || 0} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  padding: 20px 24px;

  width: calc(100% - 48px);

  gap: 20px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;
